export default {
  order: {},
  itemsLoading: [],
};
